export default "__VITE_ASSET__fc8d31d8__"